import request from '@/config/axios'

export interface BrokeragePosterItem {
  type: 'avatar' | 'nickname' | 'qrcode' | string
  size?: 'big' | 'medium' | 'small' | string
  style?: string
  color?: string
  align?: string
  top: number
  left: number
}

export interface BrokeragePosterVO {
  id?: number
  title: string
  bgImg: string
  items: BrokeragePosterItem[]
  thumb?: string
  status?: number
  sort?: number
  createTime?: string
}

export const getBrokeragePosterPage = async (params: any) => {
  return await request.get<PageResult<BrokeragePosterVO[]>>({
    url: '/trade/brokerage-poster/page',
    params
  })
}

export const getBrokeragePoster = async (id: number) => {
  return await request.get<BrokeragePosterVO>({ url: '/trade/brokerage-poster/get', params: { id } })
}

export const createBrokeragePoster = async (data: BrokeragePosterVO) => {
  return await request.post<number>({ url: '/trade/brokerage-poster/create', data })
}

export const updateBrokeragePoster = async (data: BrokeragePosterVO) => {
  return await request.put({ url: '/trade/brokerage-poster/update', data })
}

export const deleteBrokeragePoster = async (id: number) => {
  return await request.delete({ url: '/trade/brokerage-poster/delete', params: { id } })
}

export const updateBrokeragePosterStatus = async (id: number, status: number) => {
  return await request.put({
    url: '/trade/brokerage-poster/update-status',
    data: { id, status }
  })
}
